// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg[data-v-4a10b98a]{width:100%;height:auto}", ""]);
// Exports
module.exports = exports;
